import React, { FC } from 'react'
import { Typography, DialogActions, Button, Box, CircularProgress } from '@mui/material'
import { StatefulDialog } from 'src/components/ui'
import { DialogNames } from 'src/enums'

interface DeleteUserContractorModalProps {
  name: string;
  onDelete: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const DeleteUserContractorModal: FC<DeleteUserContractorModalProps> = ({
  name,
  onDelete,
  onCancel,
  isLoading = false
}) => {
  return (
    <StatefulDialog
      name={DialogNames.DeleteUserContractor}
      actions={
        <Box mb={2} mx={2}>
          <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={onDelete}
              disabled={isLoading}
            >
              {isLoading ? <CircularProgress color="info" size={26} /> : 'Delete'}
            </Button>
          </DialogActions>
        </Box>
      }
    >
      <Box minWidth="300px">
        <Typography variant="h6">Are you sure you want to delete {name}?</Typography>
      </Box>
    </StatefulDialog>
  )
}
